import { Outlet, createFileRoute } from '@tanstack/react-router'

import useFeatures from '@/core/utils/features/useFeatures'
import { NotFound } from '@/router/NotFound'

export const Route = createFileRoute('/company/_management/events')({
  component: RouteComponent,
})

function RouteComponent() {
  const isFeatureEnabled = useFeatures('learnpath-blended-learning')

  if (!isFeatureEnabled) {
    return <NotFound />
  }

  return <Outlet />
}
